<template>
  <div class="mx-lg-5">
    <section v-if="!showAll">
      <b-list-group class="px-3 text-center my-2" v-for="(item, idx) in options" :key="idx">
        <b-list-group-item
          v-if="idx < 4"
          class="flex-column align-items-start shadow border-0 px-2"
        >
          <h5 class="mb-2">{{ item.text }}</h5>
          <p class="mb-1 mx-3">{{ item.short_description }}</p>
          <div class="d-flex w-100 justify-content-between">
            <b-button
              class="h-auto w-50 bg-aside01-outline p-1 m-1"
              pill
              @click="goDescription(item.id)"
            >
              Learn more
            </b-button>
            <b-button
              class="h-auto w-50 bg-aside03-outline p-1 m-1"
              pill
              @click="redirectToParentGoals()"
            >
              Parent Goals
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </section>

    <b-link
      v-if="!showAll && options.length > 4"
      class="text-right d-block py-2 px-4 small mb-4"
      @click="showAll = true"
    >
      <p class="m-0 d-inline align-middle">Show all</p>
      <span class="material-icons align-middle">expand_more</span>
    </b-link>

    <section v-if="showAll" class="mb-4">
      <b-list-group class="px-3 text-center my-2" v-for="(item, idx) in options" :key="idx">
        <b-list-group-item class="flex-column align-items-start shadow border-0 px-2">
          <h5 class="mb-2">{{ item.text }}</h5>
          <p class="mb-1 mx-3">{{ item.short_description }}</p>
          <div class="d-flex w-100 justify-content-between">
            <b-button
              class="h-auto w-50 bg-aside01-outline p-1 m-1"
              pill
              @click="goDescription(item.id)"
            >
              Learn more
            </b-button>
            <b-button
              class="h-auto w-50 bg-aside03-outline p-1 m-1"
              pill
              @click="redirectToParentGoals()"
            >
              Parent Goals
            </b-button>
          </div>
        </b-list-group-item>
      </b-list-group>
    </section>
  </div>
</template>
<script>
export default {
  props: {
    options: [Array, Object],
  },
  data() {
    return {
      showAll: false,
    };
  },
  methods: {
    redirectToParentGoals() {
      this.$router.push({ name: 'PlanMain' });
    },
    goDescription(id) {
      this.$router.push({
        name: 'HelpDescription',
        query: {
          skill: id,
        },
      });
    },
  },
};
</script>
